export default __webpack_public_path__ + "static/media/about.d0ed7a7d.png";